export default {
  // Common words
  enter: "Introdu",
  next: "Următorul",
  previous: "Anterior",
  finish: "Finalizează",
  returnToWebsite: "Întoarce-te la site",
  complete: "Completează",
  submit: "Trimite",
  cancel: "Anulează",
  yes: "Da",
  no: "Nu",
  skip: "Sari peste",
  close: "Închide",
  discard: "Renunță",
  save: "Salvează",
  "thank-you": "Mulțumesc",
  select: "Selectează",
  hi: "Salut",
  hello: "Bună",
  link: "Link",
  back: "Înapoi",
  view: "Vizualizează",
  continue: "Continuă",
  of: "din",

  // Client Survey Main
  "client-survey-main-thanks-note":
    "Mulțumim că v-ați luat timpul, feedback-ul dumneavoastră ne ajută să ne modelăm <br /> oferta pentru viitor.",
  "client-survey-how-likely-recommend":
    "Cât de probabil ar fi să ne recomandați altora?",
  "client-survey-how-likely-note":
    "Pe o scară de la 0 la 10, unde 0 înseamnă deloc probabil și 10 înseamnă extrem de probabil.",
  "client-survey-how-likely-recommend-question":
    "Care este lucrul pe care l-am putea face pentru a vă face mai probabil să ne recomandați?",
  "step-of": "Pasul {step} din {total}",
  step: "Pasul {step}",
  "client-survey-how-satisfied-with-service":
    "Cât de mulțumit sunteți de serviciul nostru",
  "client-survey-how-satisfied-with-service-question":
    "Care este lucrul pe care l-am putea face pentru a ne îmbunătăți?",
  "client-survey-how-satisfied-with-food":
    "Cât de mulțumit sunteți de mâncarea pe care o primiți de la noi?",
  "client-survey-how-satisfied-with-food-question":
    "Care este lucrul pe care l-am putea face pentru a ne îmbunătăți?",
  "client-survey-what-is-the-best-thing-about-working-with-us":
    "Care este cel mai bun lucru la colaborarea cu noi? Vă rugăm să selectați tot ce contează.",
  "management-team": "Echipa de management",
  "the-front-line-operations-team": "Echipa operațională din prima linie",
  "food-offering": "Oferta de mâncare",
  innovation: "Inovație",
  communication: "Comunicare",
  "flexibility-and-responsiveness": "Flexibilitate și receptivitate",
  billing: "Facturare",
  "health-and-hygiene-standards": "Standarde de sănătate și igienă",
  "if-other-please-specify": "Dacă altceva, vă rugăm să specificați...",
  "based-on-the-service-we-provide-where-can-we-improve-the-most-please-select-all-that-matters":
    "Pe baza serviciului pe care îl oferim, unde ne putem îmbunătăți cel mai mult? Vă rugăm să selectați tot ce contează.",
  "please-can-we-have-some-more-detail":
    "Vă rugăm să ne oferiți mai multe detalii?",
  "to-help-us-understand-your-csr-priorities-please-order-in-rank-of-importance-the-following":
    "Pentru a ne ajuta să înțelegem prioritățile dumneavoastră CSR, vă rugăm să ordonați în ordinea importanței următoarele:",
  "sustainable-ingredients": "Ingrediente sustenabile",
  "food-waste": "Risipa alimentară",
  "local-sourcing": "Aprovizionare locală",
  "people-and-communities": "Oameni &amp; Comunități",
  "energy-reduction": "Reducerea energiei",
  "working-with-local-communities": "Colaborarea cu comunitățile locale",
  "environmental-choices": "Alegeri de mediu",
  "meat-free": "Fără carne",
  "less-plastic": "Mai puțin plastic",
  "would-you-like-to-be-contacted-about-your-feedback":
    "Ați dori să fiți contactat în legătură cu feedback-ul dumneavoastră? Dacă da, vă rugăm să lăsați informațiile de contact mai jos",
  "full-name": "Nume complet",
  "email-address": "Adresa de email",
  "phone-number": "Numărul de telefon",
  feedback: "Feedback",
  "view-our-privacy-policy":
    "Vizualizați politica noastră de confidențialitate",
  "thank-you-for-taking-time-to-complete-the-survey":
    "Mulțumim că v-ați luat timpul să completați sondajul!",

  // 404 Not Found
  "404-not-found": "404 Nu a fost găsit",

  // Privacy Policy
  "privacy-policy": "Politica de confidențialitate",

  // Employee Web Rating Feedback Step 1
  "employee-web-rating-feedback-step-1-positive":
    "Ne bucurăm să auzim că vă simțiți pozitiv, ne-ar plăcea să știm de ce?",
  "employee-web-rating-feedback-step-1-negative":
    "Ne pare rău să auzim că nu vă simțiți cel mai bine, ne puteți spune de ce?",

  // Employee Web Rating Feedback Step 2
  "employee-web-rating-feedback-step-2-heading":
    "Există altceva pe care ați dori să îl împărtășiți cu noi astăzi?",
  "employee-web-rating-feedback-step-2-information":
    "Aveți comentarii sau feedback despre experiența dumneavoastră cu noi astăzi?",
  "employee-web-rating-feedback-step-2-placeholder":
    "Împărtășiți-ne experiența dumneavoastră cu noi astăzi...",

  // Employee Web Rating Feedback Step 3
  "employee-web-rating-feedback-step-3-heading":
    "Ați dori să felicitați pe cineva?",
  "no-employees-found": "Nu au fost găsiți angajați",

  // Employee Web Rating Home
  "choose-location": "Alegeți locația",
  "search-location": "Căutați locația",
  "feedback-anonymous": "Doriți să vă păstrați feedback-ul anonim?",
  "feedback-feeling-today": "Cum vă simțiți astăzi?",

  // Employee Web Rating Thankyou Page
  "thank-you-for-your-feedback": "Mulțumim pentru feedback-ul dumneavoastră!",
  "back-to-home": "Înapoi acasă",
  page: "Pagina",

  // Feedback Once Alert
  "feedback-once-alert": "Feedback-ul a fost dat o dată de la acest URL.",

  // Front Customer Audit
  "please-answer-above-question":
    "Vă rugăm să răspundeți la întrebarea de mai sus.",
  "add-comments": "Adăugați comentarii",
  "enter-answer": "Introduceți răspunsul",
  "add-upload-files": "Adăugați fișiere de încărcat",

  // Alphega Questions
  "did-you-buy-medicine-in-the-pharmacy-today":
    "Ați cumpărat medicamente din farmacie astăzi?",
  "were-you-asked-any-of-the-following":
    "Vi s-a întrebat oricare dintre următoarele:",
  "who-is-the-medicine-for": "Pentru cine este medicamentul?",
  "what-are-your-symptoms": "Care sunt simptomele dumneavoastră?",
  "how-long-you-had-the-symptoms": "De cât timp aveți simptomele?",
  "what-action-you-have-already-taken": "Ce măsuri ați luat deja?",
  "are-you-taking-any-other-medication": "Luați alte medicamente?",

  // Alphega - Other Companies Questions
  "did-you-wait-more-than-10-minutes-to-be-served":
    "Ai așteptat mai mult de 10 minute pentru a fi servit?",
  "were-the-products-you-wanted-in-stock":
    "Au fost produsele pe care le-ai dori în stoc?",
  "were-the-staff-friendly-and-helpful": "Au fost angajații prieteni și utili?",
  "did-you-receive-any-advice-about-your-medicines":
    "Ai primit vreo recomandare despre medicamentele tale?",

  // Front Mobile Home
  "how-was-your-experience-with-us-today":
    "Cum a fost experiența dumneavoastră cu noi astăzi?",

  // Front Mobile Thankyou Page
  "thank-you-for-your-time-and-your-answers":
    "Mulțumim pentru timpul și răspunsurile dumneavoastră.",
  "would-also-like-to-rate-us-on-google":
    "Ați dori să ne evaluați și pe Google?",
  "rate-us-now": "Evaluați-ne acum",

  // Negative Chat Reply
  "select-skill": "Selectați abilitatea",
  "none-selected": "Nimic selectat",
  "can-we-get-in-touch-with-you-about-your-experience-today":
    "Putem să vă contactăm în legătură cu experiența dumneavoastră de astăzi?",
  "write-here": "Scrieți aici...",
  "please-can-we-get-your-name": "Vă rugăm să ne spuneți numele?",
  "please-enter-your-email": "Vă rugăm să introduceți email-ul:",
  "enter-your-phone-number": "Introduceți numărul de telefon:",
  "please-tell-us-a-bit-more-about-your-experience":
    "Vă rugăm să ne spuneți puțin mai mult despre experiența dumneavoastră:",
  "you-have-already-submitted-rating": "Ați trimis deja evaluarea",
  "sorry-to-hear-you-didn-t-have-the-best-experience-today-with-us-please-could-you-highlight-what-went-wrong":
    "Ne pare rău să auzim că nu ați avut cea mai bună experiență astăzi cu noi, ați putea să evidențiați ce a mers prost?",

  // Positive Chat Reply
  "select-employee": "Selectați angajatul",
  "we-d-love-to-know-who-looked-after-you-today":
    "Ne-ar plăcea să știm cine s-a ocupat de dumneavoastră astăzi?",
  "what-stood-out-to-you-today": "Ce v-a impresionat astăzi?",
  "did-we-provide-exceptional-service-today":
    "Am oferit un serviciu excepțional astăzi?",
  "do-you-have-any-comments-or-feedback-about-your-experience-with-us-today":
    "Aveți comentarii sau feedback despre experiența dumneavoastră cu noi astăzi?",

  // Client Connect Director
  "message-from-leadership": "Mesaj de la conducere",
  "message-from-leadership-text":
    "Caut în permanență modalități de a ne îmbunătăți ofertele pentru clienții noștri. Există aspecte pe care le-am putea îmbunătăți în opinia dumneavoastră?",
  "client-connect-director-another-note":
    "Pe de altă parte, dacă există un subiect specific pe care ați dori ca echipa noastră să îl abordeze, nu ezitați să îl împărtășiți. Nu sunt aici doar să ascult, ci să mă implic și să acționez asupra preocupărilor sau ideilor dumneavoastră.",
  "your-message-here": "Mesajul dumneavoastră aici",
  "visit-information": "Informații despre vizită",
  "visit-time-out": "Ora de ieșire din vizită",
  "contact-information": "Informații de contact",
  "client-connect-director-contact-information-text":
    "Pentru a oferi asistență îmbunătățită, vă rugăm să ne furnizați detaliile dumneavoastră, inclusiv numele, adresa de email și numărul de contact. Aceste informații ne vor permite să răspundem prompt și să vă contactăm.",
  name: "Nume",
  "enter-your-name": "Introduceți numele",
  email: "Email",
  "enter-your-email": "Introduceți email-ul",
  "contact-number": "Numărul de contact",
  "please-enter-your-name": "Vă rugăm să introduceți numele",
  "please-enter-your-email-or-phone-number":
    "Vă rugăm să introduceți email-ul sau numărul de telefon",
  "invalid-email-address": "Adresă de email invalidă",
  "invalid-phone-number-format":
    "Număr de telefon invalid pentru țara selectată.",
  "no-match-found": "Nicio potrivire",
  "phone-number-must-be-digits-for-country":
    "Numărul de telefon trebuie să aibă {count} cifre pentru țara selectată ({current}/{count}).",
  "phone-number-must-be-digits-range-for-country":
    "Numărul de telefon trebuie să aibă între {min} și {max} cifre pentru țara selectată ({current}/{max}).",
  "please-select-time": "Vă rugăm să selectați ora",
  "you-must-provide-at-least-one-answer-before-submitting-the-survey":
    "Trebuie să furnizați cel puțin un răspuns înainte de a trimite sondajul.",

  // Mobile Survey Questions CheckBoxType
  comment: "Comentariu",
  "comment-is-required": "Comentariul este obligatoriu!",
  "minimum-selection-is": "Selecția minimă este {min_options}",
  "maximum-selection-is": "Selecția maximă este {max_options}",
  "this-question-is-required": "Această întrebare este obligatorie!",
  "please-fill-all-required-grid-rows":
    "Vă rugăm să completați toate rândurile obligatorii din grilă!",
  "please-fill-mandatory-fields-to-continue":
    "Vă rugăm să completați câmpurile obligatorii pentru a continua",

  // Mobile Survey Questions CommentsAndImage
  "please-select-valid-image-files":
    "Vă rugăm să selectați fișiere imagine valide.",

  // Mobile Survey Questions EmployeeType
  loading: "Se încarcă",
  "getting-employee": "Se obține angajatul...",

  // Mobile Survey Questions FileUploadType
  "please-select-valid-image-or-video-files":
    "Vă rugăm să selectați fișiere imagine sau video valide.",
  "please-select-a-valid-file":
    "Vă rugăm selectați un fișier valid (imagine, video, PDF sau Word).",

  // Mobile Survey Questions NumberType
  "please-enter-a-number-without-any-decimal-points":
    "Vă rugăm să introduceți un număr fără virgule zecimale.",
  "please-enter-a-number-less-than-or-equal-to":
    "Vă rugăm să introduceți un număr mai mic sau egal cu {max_number_value}.",

  // Mobile Survey Questions SignatureType
  "please-complete-your-signature": "Vă rugăm să vă completați semnătura.",

  // Mobile Survey Questions TextType
  "please-enter-valid-email-address":
    "Vă rugăm să introduceți o adresă de email validă.",
  "phone-number-should-be-10-digit":
    "Numărul de telefon trebuie să aibă 10 cifre.",
  "please-enter-at-least-characters":
    "Vă rugăm să introduceți cel puțin {minimum_character} caractere.",
  "select-date": "Selectați data",
  "select-time": "Selectați ora",
  "client-connect-date-picker-aria":
    "Dată: {value}. Deschideți selectorul de dată",
  "client-connect-time-picker-aria":
    "Oră: {value}. Deschideți selectorul de oră",
  "select-country": "Selectați țara",

  // Report Page
  "click-the-link-to-see-how": "Faceți clic pe link pentru a vedea cum.",
  "adding-your-teams-to-the-ServeFirst-reporting-platform":
    "Că prin adăugarea echipelor dumneavoastră pe platforma de raportare ServeFirst, acestea se pot conecta și pentru a-și vedea performanța, de asemenea; aveți posibilitatea să vă gestionați echipa și să accesați rapoarte suplimentare pentru a înțelege cum performați în general -",
  "did-you-know": "Știați că..",
  count: "numărul",
  average: "media",
  focus: "focalizare",
  performance: "Performanță",
  "you-can-create-bespoke-action-plans":
    "Puteți crea planuri de acțiune personalizate care se filtrează direct aici dacă sunt create în contul dumneavoastră ServeFirst, aici puteți crea acțiuni, cronologii și proprietari instant în timp ce urmăriți performanța. -",
  "no-of-times-raised": "Nr. de ori ridicat",
  action: "Acțiune",
  "attribute-name": "Numele atributului",
  "action-plan": "Planul de acțiune",
  "that-by-adding-your-teams-to-the-ServeFirst-reporting-platform":
    "Că prin adăugarea echipelor dumneavoastră pe platforma de raportare ServeFirst, acestea se pot conecta și pentru a-și vedea performanța, de asemenea; aveți posibilitatea să vă gestionați echipa și să accesați rapoarte suplimentare pentru a înțelege cum performați în general -",
  result: "Rezultat",
  category: "Categoria",
  "your-location-vs-all-location": "Locația dumneavoastră vs. Toate locațiile",
  "net-promoter-score": "Scorul Net Promoter",
  "responses-breakdown": "Defalcarea răspunsurilor",
  "trended-net-promoter-score": "Scorul Net Promoter în tendință",
  "trended-results": "Rezultate în tendință",
  "net-promoter-score-info":
    "Scorul Net Promoter se bazează pe % de promotori (Scor 5/5) - % de detractori (Scor 1, 2 sau 3), puteți afla mai multe despre Scorul Net Promoter făcând clic pe următorul",
  "customer-feedback": "Feedback-ul clienților",
  logan: "Logan",
  "top-performer": "Cel mai bun performer",
  "rank-in-the-country": "Clasamentul în țară",
  "ytd-score": "Scorul YTD",
  "score-during-period": "Scorul în perioada",
  "0-from-last-month": "0 din luna trecută",
  "total-responses-for-july-2021": "Total răspunsuri pentru iulie 2021",
  promoter: "Promotor",
  "from-04-sep-2021-to-06-sep-2021": "De la 04 Sep, 2021 la 06 Sep, 2021",
  "the-focus-currently-is-on": "Focalizarea în prezent este pe",
  "1-number-of-customers-have-stated-this-as-an-opportunity":
    "1 numărul de clienți au declarat aceasta ca o oportunitate.",
  "focus-for-the-month": "Focalizarea pentru lună",
  "download-pdf": "Descărcați pdf",

  // Report Page New Report
  "total-responses": "Total răspunsuri",
  duration: "Durata",
  "customers-have-stated-this-as-an-opportunity":
    "clienții au declarat aceasta ca o oportunitate",
  "error-fetching-params": "Eroare la obținerea parametrilor!",
  "previous-days-was": "Zilele anterioare {days} au fost {score}",

  // Report Page Common LgCard
  "raised-on": "# Ridicat pe",
  results: "Rezultate",

  // Report Page Components AiSuggestions
  "analyzing-data-please-wait":
    "Se analizează datele, vă rugăm să așteptați...",

  // Report Page Components CustomerFeedBack
  "view-report": "Vizualizați raportul",
  "received-on": "Primit pe",

  // Report Page Components ResponseBreakdown
  detractors: "Detractori",
  nps: "NPS",

  // Report Page Components TrendResults
  "trend-results": "Rezultate în tendință",

  // Survey helpers Utils
  "failed-to-fetch-the-pdf-file": "Nu s-a putut obține fișierul PDF",
  "error-generating-pdf-thumbnail": "Eroare la generarea miniaturii PDF",
  "error-in-thumbnail-generation-function":
    "Eroare în funcția de generare a miniaturii",
  "failed-to-generate-pdf-thumbnail": "Nu s-a putut genera miniatura PDF",

  // Survey Pages Audition
  "select-audit": "Selectați auditul",

  // Survey Pages ClientConnect
  "select-atleast-min-options": "Selectați cel puțin {minOptions} opțiuni",
  "select-max-options": "Maxim {maxOptions} opțiuni permise!",
  "error-saving-your-response": "Eroare la salvarea răspunsului dumneavoastră!",
  "failed-to-load-the-file": "Nu s-a putut încărca fișierul!",
  "open-link": "Deschideți linkul",
  download: "Descărcați",
  details: "Detalii",
  title: "Titlu",
  description: "Descriere",
  "general-info": "Informații generale",
  type: "Tip",
  size: "Mărime",
  "uploaded-by": "Încărcat de",

  // Survey Pages ClientConnect Intro
  "thank-you-for-your-time": "Mulțumim pentru timpul dumneavoastră!",

  // Survey Pages ClientConnect Content
  "review-content": "Revizuiți conținutul",

  // Survey Pages ClientConnect Survey
  "please-give-us-your-feedback":
    "Vă rugăm să ne oferiți feedback-ul dumneavoastră",
  "enter-your-response": "Introduceți răspunsul dumneavoastră",

  // Client Connect v2 (accordion UI)
  "client-connect-preview-hey": "Bună, {name}",
  "client-connect-preview-sent-from": "Trimis de {sender} - {date}",
  "client-connect-preview-step-of": "Pasul {current} din {total}",
  "client-connect-preview-getting-started": "Primii pași",
  "client-connect-preview-getting-started-desc":
    "Consultați resursele de prezentare pregătite pentru dvs.",
  "client-connect-preview-share-feedback": "Împărtășiți feedback-ul",
  "client-connect-preview-share-feedback-desc":
    "Opinia dvs. ne ajută să construim o experiență mai bună pentru dvs.",
  "client-connect-preview-talk-leadership": "Discutați cu conducerea",
  "client-connect-preview-talk-leadership-desc":
    "Citiți mesajul conducerii și salvați răspunsul dvs.",
  "client-connect-preview-reviewed-these": "Le-am revizuit",
  "client-connect-preview-send-feedback": "Trimiteți feedback",
  "client-connect-preview-finish-submit": "Finalizați și trimiteți",
  "client-connect-preview-save-finish": "Finalizați și trimiteți",
  "client-connect-preview-your-reply": "Răspunsul dvs.",
  "client-connect-preview-saved": "Salvat",
  "client-connect-preview-edit": "Editați",
  "client-connect-preview-pop-out": "Deschideți în fereastră",
  "client-connect-preview-open": "Deschideți",
  "client-connect-preview-view": "Vizualizați",
  "client-connect-preview-welcome": "Bun venit",
  "client-connect-preview-feedback": "Feedback",
  "client-connect-preview-save-message": "Trimiteți mesajul",
  "client-connect-preview-message-footer":
    "Mesajul dvs. merge direct către echipa de conducere.",
  "client-connect-preview-leadership-placeholder": "Introduceți mesajul dvs...",
  "client-connect-preview-thank-you": "Mulțumim",
  "client-connect-preview-thank-you-body":
    "Ați finalizat Client Connect. Răspunsurile la sondaj și mesajul dvs. au fost trimise echipei — vă vor contacta în curând.",
  "client-connect-thank-you-message":
    "Vă mulțumim pentru timpul acordat. Feedbackul dvs. face cu adevărat diferența.",
  "client-connect-preview-review-answers": "Revizuirea răspunsurilor mele",
  "client-connect-preview-back-dashboard": "Înapoi la panou",
  "client-connect-preview-already-submitted":
    "Feedback-ul dvs. a fost primit. Vă mulțumim! Nu ezitați să explorați materialele de mai sus.",
  "enter-email-address": "Introduceți Adresa de Email",
  "enter-phone-no": "Introduceți Numărul de Telefon",
  "product-type": "Tip produs",
  "enter-number": "Introduceți numărul",
  aspect: "Aspect",

  // Survey Pages ClientConnect Director
  "i-am-constantly-seeking-ways-to-better-our-offerings-for-our-clientele":
    "Caut în permanență modalități de a ne îmbunătăți ofertele pentru clienții noștri. Există aspecte pe care le-am putea îmbunătăți în opinia dumneavoastră?",
  "on-another-note-if-there-s-a-specific-topic-you-d-like-our-team-to-address-don-t-hesitate-to-share":
    "Pe de altă parte, dacă există un subiect specific pe care ați dori ca echipa noastră să îl abordeze, nu ezitați să îl împărtășiți. Nu sunt aici doar să ascult, ci să mă implic și să acționez asupra preocupărilor sau ideilor dumneavoastră.",
  "to-provide-enhanced-assistance-we-kindly-ask-for-your-details-including-your-name-email-address-and-contact-number":
    "Pentru a oferi asistență îmbunătățită, vă rugăm să ne furnizați detaliile dumneavoastră, inclusiv numele, adresa de email și numărul de contact. Aceste informații ne vor permite să răspundem prompt și să vă contactăm.",

  // Survey Pages Location
  "select-the-location-you-visited": "Selectați locația pe care ați vizitat-o",
  locations: "Locații",
  "is-this-your-current-location":
    "Aceasta este locația dumneavoastră actuală?",
  "nearest-location": "Cea mai apropiată locație",
  "loading-data": "Se încarcă datele...",
  "please-wait": "Vă rugăm să așteptați!",

  // Survey Pages Location Area
  "location-area": "Zona locației",
  "select-location-area": "Selectați zona locației",

  // Survey Pages Login
  "please-enter-your-password": "Vă rugăm să introduceți parola",
  "value-must-be-longer-than-3-characters":
    "Valoarea trebuie să aibă mai mult de 3 caractere",
  "please-enter-your-email-address": "Vă rugăm să introduceți adresa de email",
  password: "Parola",
  "internal-server-error": "Eroare internă de server !",
  "sign-in": "Conectați-vă",

  // Survey Pages SameDaySurvey
  "you-have-already-performed-this-survey": "Ați efectuat deja acest sondaj !",
  "csat-link-invalid": "Acest link către sondaj nu mai este valid.",

  // Survey Pages SurveyThankYou
  "your-feedback-has-been-submitted":
    "Feedback-ul dumneavoastră a fost trimis. Numărul biletului dumneavoastră este #",
  "a-member-of-the-team-will-be-in-touch-shortly":
    "Un membru al echipei vă va contacta în curând.",
  "would-you-also-like-to-rate-us-on-google":
    "Ați dori să ne evaluați și pe Google?",
  "to-review-our-terms-and-conditions-please-click":
    "Pentru a revizui termenii și condițiile noastre, vă rugăm să faceți clic",
  here: "Aici",
  "ticket-number-copied-to-clipboard":
    "Numărul biletului a fost copiat în clipboard",

  // Survey Pages Welcome
  "visit-date": "Data vizitei",
  "visit-time-in": "Ora de intrare în vizită",
  "please-select-date": "Vă rugăm să selectați data",
  "guest-info": "Informații oaspete",
  "please-select-user": "Vă rugăm să selectați utilizatorul",
  "get-started": "Începeți",

  // Survey Pages InventoryType
  "enter-value": "Introduceți valoarea",
  "getting-product-list": "Se obține lista de produse...",

  // Survey Pages NotesAndImage
  "upload-file": "Încărcați fișierul",

  // Survey Pages NumberType
  "enter-digit": "Introduceți cifra",

  // Survey Pages TextArea
  "enter-your-comment": "Introduceți comentariul dumneavoastră",

  // Survey Pages Upload
  "file-size-should-be-less-than-10-mb":
    "Mărimea fișierului trebuie să fie mai mică de 10 MB",
  "drag-you-files-here-file-size-less-than-10-mb-or":
    "Trageți fișierele aici, mărimea fișierului mai mică de 10 MB sau",
  "upload-or-drag-and-drop-your-files-here":
    "Încărcați sau trageți și plasați fișierele aici",
  "browse-files": "Răsfoiți fișierele",

  // Survey Pages Questions
  "next-question": "Următoarea întrebare",
  "save-and-exit": "Salvează și ieși",
  "failed-to-save-and-exit":
    "Nu s-a putut salva progresul. Vă rugăm să încercați din nou.",
  "progress-saved-you-may-close-this-tab":
    "Progresul dvs. a fost salvat. Puteți închide acest tab al browserului.",
  "please-enter-at-least": "Vă rugăm să introduceți cel puțin {min} caractere.",
  "contact-no": "Nr. de contact",
  "please-select-location": "Vă rugăm să selectați locația!",
  "please-select-survey": "Vă rugăm să selectați sondajul!",
  "please-enter-your-email-address-or-phone-number":
    "Vă rugăm să introduceți adresa de email sau numărul de telefon.",

  // Utils CompressFiles
  "compression-error": "Eroare de compresie:",

  // Web Rating FrontLogin
  "enter-location-id": "Introduceți ID-ul locației",
  "invalid-location-id": "ID locație invalid",
  "location-id-required": "ID-ul locației este obligatoriu",

  // Web Rating Index
  "please-tell-us-how-your-experience-was-today":
    "Vă rugăm să ne spuneți cum a fost experiența dumneavoastră astăzi.",

  // Web Rating Negativefeedback
  "sorry-to-hear-you-didn-t-have-the-best-experience-today-with-us-please-could-you-highlight-what-went-wrong":
    "Ne pare rău să auzim că nu ați avut cea mai bună experiență astăzi cu noi, ați putea să evidențiați ce a mers prost?",
  "enter-valid-email-address": "Introduceți o adresă de email validă.",
  "can-we-get-in-touch-with-you": "Putem să vă contactăm?",

  // Web Rating Positivefeedback
  "enter-your-telephone-number": "Introduceți numărul de telefon",
  "write-your-feedback": "Scrieți feedback-ul dumneavoastră",

  // Web Rating Positivefeedback2
  "what-made-the-employee-name-stand-out-to-you":
    "Ce a făcut ca {employeeName} să vă impresioneze?",
  team: "Echipa",

  // Web Rating PositivefeedbackForm
  "please-go-to-previous-step-and-select-employee-without-employee-selection-not-able-to-submit-feedback-form":
    "Vă rugăm să mergeți la pasul anterior și să selectați angajatul, fără selecția angajatului nu se poate trimite formularul de feedback",
  "share-us-your-experience-with-us-today":
    "Împărtășiți-ne experiența dumneavoastră cu noi astăzi...",
  "did-employee-name-provide-exceptional-service":
    "A oferit {employeeName} un serviciu excepțional?",
  "did-employee-name-stand-out-for-delivering-exceptional-service":
    "S-a remarcat {employeeName} prin oferirea unui serviciu excepțional?",

  // Web Rating New apiHelpers loginHelpers
  "please-enter-user-name": "Vă rugăm să introduceți numele de utilizator",
  "please-enter-password": "Vă rugăm să introduceți parola",

  // Web Rating New RatingLocations
  search: "Căutați",
  "select-loction-to-ratings": "Selectați locația pentru evaluări",
  location: "Locația",
  "is-this-your-location": "Aceasta este locația dumneavoastră?",
  "fetch-details-failed": "Obținerea detaliilor a eșuat",

  // Web Rating New PositiveJourny EmployeDetail
  "click-as-many-as-you-want": "Faceți clic pe câte doriți",
  "what-made-employee-name-stand-out-to-you":
    "Ce a făcut ca {employeeName} să vă impresioneze?",
  "what-made-the-team-stand-out-to-you":
    "Ce a făcut ca echipa să vă impresioneze?",

  // Web Rating New PositiveJourny EmployeService
  "did-we-stand-out-for-delivering-exceptional-service":
    "Ne-am remarcat prin oferirea unui serviciu excepțional?",

  // Web Rating New NegativeJourny EmployePersonalDetail
  "leave-an-email-or-phone-number-if-you-want-us-to-get-in-touch-otherwise-just-leave-it-blank-then-press-next":
    "Lăsați un email sau număr de telefon dacă doriți să vă contactăm, altfel lăsați-l gol apoi apăsați următorul",
  "anything-else-you-d-like-to-share":
    "Altceva pe care ați dori să îl împărtășiți?",
  "enter-valid-email": "Introduceți un email valid",
  message: "Mesaj",
  "by-signing-up-the-form-you-agree-to-our-terms-and-privacy":
    "Prin înregistrarea formularului, sunteți de acord cu termenii și confidențialitatea noastră.",

  // Web Rating New FrontWebLogin
  login: "Conectare",
  username: "Numele de utilizator",

  // Web Rating New FrontRating
  "press-the-facial-expression-that-best-represents-how-you-feel-about-your-experience":
    "Apăsați expresia facială care reprezintă cel mai bine cum vă simțiți în legătură cu experiența dumneavoastră.",
  "getting-employee-list": "Se obține lista de angajați",
  "getting-skill-data": "Se obțin datele despre abilități",
  "getting-screen-saver": "Se obține economizorul de ecran",

  // Web Rating New CommonComponents ThankYouModal
  "thank-you-for-contacting-us": "Mulțumim că ne-ați contactat.",
  "we-ll-be-in-touch-very-soon": "Vă vom contacta foarte curând.",

  // Web Rating New CommonComponents GoogleQrPage
  "you-can-follow-this-button-to-rate-us-on-google":
    "Puteți urma acest buton pentru a ne evalua pe Google",
  "rate-us-on-google": "Evaluați-ne pe Google",

  // Web Rating New CommonComponents ContactUsModal
  "contact-us": "Contactați-ne",
  "or-you-may-reach-us-on": "...sau ne puteți contacta la.",
  "do-you-want-to-learn-more-about-serve-first":
    "Doriți să aflați mai multe despre Serve First?",

  // Web Rating New CommonComponents BottomBar
  saving: "Se salvează",
  "please-enter-only-digits-for": "Vă rugăm să introduceți doar cifre pentru",
  "please-enter": "Vă rugăm să introduceți",
  "enter-value-here": "Introduceți valoarea aici",

  // Survey Pages Questions Dropdown
  "please-select": "Vă rugăm să selectați",
  "survey-retry-message":
    "Veți putea efectua acest sondaj după {value} {unit}.",
  minute: "minut",
  minutes: "minute",
  hour: "oră",
  hours: "ore",
  day: "zi",
  days: "zile",
  week: "săptămână",
  weeks: "săptămâni",
  month: "lună",
  months: "luni",
  clear: "Ștergeți",

  "powered-by": "Alimentat de",
  "image-is-required": "Imagine este obligatorie",
  "please-fill-all-required-contact-information":
    "Vă rugăm să completați toate informațiile de contact obligatorii",

  "please-leave-any-extra-feedback-in-the-box-below":
    "Vă rugăm să lăsați orice feedback suplimentar în caseta de mai jos.",
  "all-feedback-is-confidential": "Toate feedback-urile sunt confidențiale",
  "your-feedback-has-been-received-thank-you":
    "Feedback-ul dumneavoastră a fost primit, mulțumim",
  "close-page": "Închide pagina",
  send: "Trimite",
  sending: "Se trimite",
  "enter-your-feedback-here": "Introduceți feedback-ul dumneavoastră aici",
  "for-anything-else-please":
    "Pe de altă parte, dacă există un subiect specific pe care ați dori ca echipa noastră să îl abordeze, nu ezitați să îl împărtășiți. Nu sunt aici doar să ascult, ci să mă implic și să acționez asupra preocupărilor sau ideilor dumneavoastră.",
  "please-correct-the-custom-field-values":
    "Vă rugăm să corectați valorile pentru câmpurile personalizate",
  "please-complete-all-required-contact-information":
    "Vă rugăm să completați toate informațiile de contact obligatorii",
  "survey-cannot-be-submitted": "Sondajul nu poate fi trimis",
  "please-enter-your-phone": "Vă rugăm să introduceți numărul de telefon",
  "network-error-please-try-again":
    "Eroare de rețea. Verificați conexiunea și încercați din nou.",
  "no-results-found": "Nu s-au găsit rezultate",
  "drop-files-here": "Plasați fișierele aici...",
  "drag-drop-files":
    "Glisați și plasați fișiere aici sau faceți clic pentru a selecta fișiere",
  "max-5-files-5mb": "Max 5 fișiere, 5 MB fiecare, doar imagini",
  remove: "Șterge",

  // Learning & Development

  "ld-module-title": "Învățare și dezvoltare",
  "ld-no-sign-in-required": "Autentificare ne necesară",
  "ld-progress-warning":
    "Nu închideți această fereastră — progresul dvs. nu este salvat și ar trebui să începeți din nou.",
  "ld-loading-module": "Se încarcă modulul de învățare…",
  "ld-unable-load-module": "Nu se poate încărca modulul de învățare.",
  "ld-package-not-configured": "Pachetul de învățare nu este configurat.",
  "ld-start-guidance": "Începe instruirea",
  "ld-due-date": "Termen {date}",
  "ld-whats-involved": "Ce presupune",
  "ld-your-progress": "PROGRESUL DVS.",
  "ld-step-of": "Pasul {current} din {total}",
  "ld-watched-in-full": "Vizionat integral",
  "ld-video-no-skip": "Puteți derula înapoi, dar nu înainte",
  "ld-video-muted-counts": "Fără sunet — redarea contează în continuare",
  "ld-maximize-document": "Maximizați documentul",
  "ld-minimize-document": "Minimizați documentul",
  "ld-read-percent": "{percent} % citit",
  "ld-end-of-document": "Sfârșitul documentului",
  "ld-scroll-to-continue": "Derulați pentru a continua",
  "ld-read-to-end": "Citit până la final",
  "ld-read-to-end-to-continue": "Citiți până la final pentru a continua",
  "ld-loading-document": "Se încarcă documentul…",
  "ld-pdf-preview-unavailable":
    "Nu se poate previzualiza acest PDF în browser.",
  "ld-pdf-page-alt": "{title} — pagina {page}",
  "ld-knowledge-check": "VERIFICARE CUNOȘTINȚE",
  "ld-knowledge-check-title": "{title} — verificare cunoștințe",
  "ld-quiz-instruction":
    "Răspundeți la {count, plural, one {# întrebare} few {# întrebări} other {# de întrebări}}. Nota de trecere {passMark} %.",
  "ld-quiz-instruction-pass-only": "Nota de trecere {passMark} %.",
  "ld-question-of": "ÎNTREBAREA {current} DIN {total}",
  "ld-guidance-of": "INSTRUIREA {current} DIN {total}",
  "ld-loading-questionnaire": "Se încarcă chestionarul…",
  "ld-preparing-questions": "Se pregătesc întrebările dvs.",
  "ld-submit-answers": "Trimite răspunsurile",
  "ld-submitting": "Se trimite…",
  "ld-ready-to-submit": "Gata de trimitere a răspunsurilor",
  "ld-answer-selected": "Răspuns selectat",
  "ld-select-answer": "Selectați un răspuns pentru a continua",
  "ld-pass-mark-note":
    "Aveți nevoie de {passMark} % sau mai mult pentru a trece. Răspunsurile nu pot fi modificate după trimitere.",
  "ld-questionnaire-not-configured": "Chestionarul nu este configurat.",
  "ld-unable-load-questionnaire": "Nu se poate încărca chestionarul.",
  "ld-no-visible-questions":
    "Nu există întrebări disponibile pentru această verificare de cunoștințe momentan.",
  "ld-unable-submit-answers":
    "Nu se pot trimite răspunsurile. Încercați din nou.",
  "ld-not-passed": "Nepromovat",
  "ld-completed": "Finalizat",
  "ld-fail-title": "Ați fost aproape — încercați din nou",
  "ld-fail-description":
    "Ați obținut {score} — nota de trecere este {passMark} %. Mai aveți {remaining}.",
  "ld-attempts-remaining":
    "{count, plural, one {# încercare} few {# încercări} other {# de încercări}}",
  "ld-attempt-of": "Încercarea {current} din {total}",
  "ld-fail-alert":
    "Acordați-vă un moment să revizuiți ghidul, apoi reluați testul. După ultima încercare, testul se va bloca.",
  "ld-try-again": "Încercați din nou",
  "ld-review-guidance": "Revizuiți ghidul",
  "ld-locked-title": "Această instruire este acum blocată",
  "ld-locked-description":
    "Ați obținut {score} — nota de trecere pentru acest pachet este {passMark} %. Din motive de conformitate, nu îl puteți relua aici.",
  "ld-speak-to-manager": "Vorbiți cu managerul dvs.",
  "ld-locked-manager-copy":
    "Managerul dvs. de serviciu poate reatribui {courseTitle} pentru a putea parcurge din nou ghidul și a relua testul.",
  "ld-close-window": "Puteți închide această fereastră.",
  "ld-close-window-safe": "Puteți închide în siguranță această fereastră.",
  "ld-success-title": "Felicitări!",
  "ld-success-description":
    "Ați finalizat cu succes {courseTitle}. Acest lucru a fost înregistrat în profilul dvs. de instruire — nu mai aveți nimic de făcut.",
  "ld-email-yourself": "Trimiteți-vă o copie prin e-mail",
  "ld-email-copy-description":
    "Trimiteți o confirmare a finalizării în căsuța dvs. de e-mail pentru evidență.",
  "ld-email-placeholder": "dvs@companie.ro",
  "ld-sent": "Trimis",
  "ld-sending-email": "Se trimite…",
  "ld-unable-send-email":
    "Nu s-a putut trimite e-mailul. Vă rugăm să încercați din nou.",
  "ld-email-sent-success": "E-mailul de confirmare a fost trimis cu succes!",
  "ld-video-briefing": "Briefing video",
  "ld-document": "Document",
  "ld-video-meta": "Video",
  "ld-video-meta-no-skip": "Video · fără salt",
  "ld-document-meta": "Document · PDF",
  "ld-document-meta-scroll": "Document · PDF · derulați până la final",
  "ld-video-instruction-full": "Urmăriți integral — nu puteți sări înainte",
  "ld-video-instruction": "Urmăriți briefingul, apoi continuați",
  "ld-document-instruction-scroll": "Derulați până la final pentru a continua",
  "ld-document-instruction": "Revizuiți documentul, apoi continuați",
  "ld-questionnaire": "Chestionar",
  "ld-confirmation": "Confirmare",
  "ld-question-count":
    "{count, plural, one {# întrebare} few {# întrebări} other {# de întrebări}}",
  "ld-knowledge-check-subtitle": "Verificare cunoștințe",
  "ld-score": "Scor",
  "ld-whats-involved-pass-mark":
    "Nota de trecere {passMark} % · se deblochează după ghid",
  "ld-document-type-pdf": "{documentType} · PDF",
};
